import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

/** Returns 'after' URL param value. */
const useCurrentPage = (): number => {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const after = searchParams.get('after')
  const currentPage = useMemo((): number => {
    if (after) {
      return parseInt(after, 10)
    }

    return 1
  }, [after])

  return currentPage
}

export default useCurrentPage
